export const SHOW_INACTIVE_FORM_LABEL = "Show Inactive";
export const ONLY_SHOW_INACTIVE_FORM_LABEL = "Only Show Inactive";
export const ADVANCED_FILTERS_BUTTON_LABEL = "Advanced Filters";

export const SEARCH_BAR_LABEL = "Search Coach";
export const TOGGLE_COACHES = "Show / Hide Coaches";



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/advanced-filters/constants.ts